import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class ApplicationsService {
  static async getApps({ page, search }) {
    const { data } = await DataService.get(API.applications.root, { page, search });
    return {
      applications: data.applications,
      total: data.total,
      pageSize: data.pageSize,
      page,
    };
  }

  static async getFormById(idApp) {
    const { data } = await DataService.get(`${API.applications.root}/${idApp}`);

    return {
      application: data.application,
    };
  }

  static async getAttachmentSignedPost({
    itemId,
    itemType,
    folder,
    contentType,
    idInput,
    parents,
  }) {
    const { data } = await DataService.get(`${API.applications.root}/${API.applications.attachmentsSignedPost}`, {
      itemId,
      itemType,
      folder,
      contentType,
      idInput,
      parents,
    });

    return {
      signedPost: data.signedPost,
      fileKey: data.fileKey,
    };
  }
}

export { ApplicationsService };
